const FETCH_INTERVAL = 20000

export const useOnlineCounts = () => {
  const counts = useState('onlineAnimeCounts', () => ({}))

  if (import.meta.client) {
    const config = useRuntimeConfig()

    const fetchCounts = async () => {
      try {
        const res = await $fetch(`${config.public.apiBase}/api/online/counts`)
        counts.value = res.animes || {}
      } catch (e) {
        // Мовчки ігноруємо мережеві збої - лічильник не критичний функціонал
      }
    }

    let timer = null

    onMounted(() => {
      fetchCounts()
      timer = setInterval(fetchCounts, FETCH_INTERVAL)
    })

    onUnmounted(() => {
      if (timer) clearInterval(timer)
    })
  }

  return counts
}
